export interface IVScrollItem {
  [key: string]: string | number;
  [key: number]: string | number;
}

export interface IVScrollOffsetTop {
  readonly isHeaderSlotVisible: boolean;
  /* Amount of items and distance from real viewport to the start of content */
  readonly offsetTopItems: number;
  readonly offsetTopDistance: number;
  /* Values above adjusted for buffer size (should be the same when there is no buffer) */
  readonly offsetTopItemsBuffer: number;
  readonly offsetTopDistanceBuffer: number;
}

export interface IVScrollOffsetBottom {
  readonly isFooterSlotVisible: boolean;
  /* Same concept as in "Offset Top", but for items below real viewport */
  readonly offsetBottomItems: number;
  readonly offsetBottomDistance: number;
  readonly offsetBottomItemsBuffer: number;
  readonly offsetBottomDistanceBuffer: number;
}

export interface IVScrollChanges {
  readonly scrollTop: number;
  readonly scrollHeight: number;
  readonly viewportHeight: number;
}

export type IVScrollPosition = 'top' | 'bottom';

export interface IBaseVirtualScrollProps {
  readonly items: IVScrollItem[];
  readonly context?: Record<string, any>;
  readonly buffer?: number;
  readonly dataKey: string;
  readonly correctScrollOnResize?: boolean;
  readonly defaultItemSize?: number;
  /* NOTE: Left for backward compatibility. Remove along with legacy BaseVirtualScroll */
  readonly activeItemId?: number | string;
  readonly unpinActiveItem?: boolean;
}

export interface IVScroll {
  readonly scrollTop: number;
  readonly viewportSize: number;
  readonly headerSlotSize: number;
  readonly footerSlotSize: number;
  readonly offsetTop: IVScrollOffsetTop;
  readonly nItemsInViewport: number;
  readonly nItemsInViewportWithBuffer: number;
  readonly offsetBottom: IVScrollOffsetBottom;
}

export interface IVScrollItemResize {
  id: string | number;
  size: number;
}

export interface IVScrollUpdateOptions {
  readonly scrollTop?: number;
  readonly resize?: IVScrollItemResize;
  readonly items?: IVScrollItem[];
  readonly viewportSize?: number;
  readonly headerSlotSize?: number;
  readonly footerSlotSize?: number;
  readonly itemSizesById?: Record<number | string, number>;
}

export interface IVScrollItemGeometry {
  size: number;
  pageOffsetTop: number;
}

export interface IVScrollRenderState {
  visibleItems: IVScrollItem[];
  scrollTop: number;
  offsetTopPx: number;
  offsetTopItems: number;
  offsetBottomPx: number;
  offsetBottomItems: number;
  isHeaderVisible: boolean;
  isFooterVisible: boolean;
}

export enum IVScrollSlot {
  HEADER = 'header',
  FOOTER = 'footer',
}
